export default "__VITE_ASSET__330ea460__"